import React, { useState,useEffect } from "react";
import { API_URL,RESPONSE_SUCCESS } from '../../GlobalConstents.js';
import { Link, useNavigate,useParams } from "react-router-dom";
import API from '../../Api.js';
import { toast } from 'react-toastify';

import {RouteChanged,ROUTE_EXAM_REPORT_DETAILS } from '../../RouteConstents';
import HeaderLayout from "./../../Layout/Header";


const SingleExamReport = () => {
    
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
   
    const [examTitle, setExamTitle] = useState('');
    const [totalQuestion, setTotalQuestion] = useState('');
    const [totalTime, setTotalTime] = useState('');
    const [AttemptedQuestion, setAttemptedQuestion] = useState('');
    const [takenTime, setTakenTime] = useState('');
    const [AttemptedType, setAttemptedType] = useState('');
    const [resultDate, setResultDate] = useState('');
    const [totalMarks, setTotalMarks] = useState('');

    const [optionClass, setOptionClass] = useState('');
    const [resultType, setResultType] = useState('');

    const [examReportId, setExamReportId] = useState('');

    const [correctQuestion, setCorrectQuestion] = useState('');
    const [wrongQuestion, setWrongQuestion] = useState('');

    
    
    
    const { string } = useParams();

    useEffect(
        () => {
        document.body.classList.add('theme-red');
        document.body.classList.remove('login-page');
        document.body.classList.remove('overlay-open');
        LoadExamReport()
    },[]); 

    const LoadExamReport = async () => {

        let objValue =  {"method_name":"singleExamReport","test_report_id":string}

        setIsLoading(true);
        await API.post(API_URL,objValue).then(function (response) {
            setIsLoading(false);
            if (response.status === RESPONSE_SUCCESS) {
                if (response.data.status === "success") {
                    
                    setExamTitle(response.data.reportInfo.examtitle)   
                    setTotalQuestion(response.data.reportInfo.totalQuestion)   
                    setTotalTime(response.data.reportInfo.totalTime);
                    setAttemptedQuestion(response.data.reportInfo.AttemptedQuestion);
                    
                    setTakenTime(response.data.reportInfo.takenTime);
                    setAttemptedType(response.data.reportInfo.AttemptedType)
                    setResultDate(response.data.reportInfo.resultDate)
                    setTotalMarks(response.data.reportInfo.totalMarks) 
                    
                    if(response.data.reportInfo.showResult === 'Pass') {
                        setResultType('Pass') 
                        setOptionClass('badge bg-green')  
                    } else {
                        setResultType('Fail') 
                        setOptionClass('badge bg-pink')
                    }

                    setExamReportId(response.data.reportInfo.examReportId)
                    
                    setCorrectQuestion(response.data.reportInfo.correctQuestion)
                    setWrongQuestion(response.data.reportInfo.wrongQuestion)
                } else {
                    toast.error(response.data.message);
                }
            }

        }).catch(function (error) {
           // ForceLogoutUser(error);
        });

    }

    const ExamAnalysis = async (examString) => {
        let newURL = RouteChanged(ROUTE_EXAM_REPORT_DETAILS,examString)
        navigate(newURL);
    } 

    
    let pageTitle = 'Knowledge Section'
    
    return (
        <>
        <HeaderLayout pageTitle={pageTitle} />
        
        <section className="content">
            <div className="container-fluid">
                <div className="block-header">
                    <h2>Exam Report</h2>
                </div>            
                <div className="row clearfix">
                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <div className="card">
                            <div className="table-responsive">
                                <table className="table table-bordered table-hover "  >
                                    <tbody>
                                        <tr>
                                            <td colSpan={2} className="text-center"><b>Test Details</b></td>
                                        </tr>
                                        <tr>
                                            <td width="49%">Exam Name</td>
                                            <td>{examTitle}</td>
                                        </tr>
                                        <tr>
                                            <td>Total Questions</td>
                                            <td>{totalQuestion}</td>
                                        </tr>
                                        <tr>
                                            <td>Total Time</td>
                                            <td>{totalTime}</td>
                                        </tr>
                                        <tr>
                                            <td>Total Marks</td>
                                            <td>{totalMarks}</td>
                                        </tr>
                                        <tr>
                                            <td colSpan={2} className="text-center">&nbsp;</td>
                                        </tr>
                                        <tr>
                                            <td colSpan={2} className="text-center"><b>Student Analysis</b></td>
                                        </tr>
                                        <tr>
                                            <td width="49%">Attempted Questions</td>
                                            <td>{AttemptedQuestion}</td>
                                        </tr>
                                        <tr>
                                            <td width="49%">Correct Questions</td>
                                            <td>{correctQuestion}</td>
                                        </tr>
                                        <tr>
                                            <td width="49%">Wrong Questions</td>
                                            <td>{wrongQuestion}</td>
                                        </tr>
                                        <tr>
                                            <td>Taken Time</td>
                                            <td>{takenTime}</td>
                                        </tr>
                                        <tr>
                                            <td>Attempted No</td>
                                            <td>{AttemptedType}</td>
                                        </tr>

                                        <tr>
                                            <td>Attempted Date</td>
                                            <td>{resultDate}</td>
                                        </tr>

                                        <tr>
                                            <td>Result</td>
                                            <td><span className={optionClass}>{resultType}</span></td>
                                        </tr>

                                        <tr> 
                                            <td colSpan={2}><button type="button" className="btn bg-purple btn-block waves-effect"  onClick={() => ExamAnalysis(examReportId)} >Exam Analysis</button></td>
                                        </tr>

                                    </tbody>
                                </table>
                            </div>
                        </div>                           
                    </div>
                </div>
            </div>
        </section>
        
        </>
    );
   
}
    
export default SingleExamReport;